import type { Observable as ObservableType } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { TransitionAndRankResponse } from './types';

export const transitionAndRankFetch = ({
	rankCustomFieldId,
	issueKeys,
	targetColumn,
	rankBeforeIssueIdOrKey,
	rankAfterIssueIdOrKey,
	rapidViewId,
	selectedTransitionId,
	calculateNewIssuesOrder = false,
}: {
	rankCustomFieldId: number;
	issueKeys: string[];
	targetColumn: number | null;
	rankBeforeIssueIdOrKey: string | null;
	rankAfterIssueIdOrKey: string | null;
	rapidViewId: number | null;
	selectedTransitionId?: number;
	calculateNewIssuesOrder?: boolean;
}): ObservableType<TransitionAndRankResponse> =>
	fetchJson$('/rest/greenhopper/1.0/xboard/transitionAndRank', {
		method: 'PUT',
		body: JSON.stringify({
			mode: 'plan',
			calculateNewIssuesOrder,
			rapidViewId,
			issueKeys,
			targetColumn,
			rankCustomFieldId,
			rankBeforeIssueIdOrKey,
			rankAfterIssueIdOrKey,
			selectedTransitionId,
		}),
	});
